<template>
  <div>

    <div class="h-panel">
      <b-button v-b-modal.help-modal>Help</b-button>
    </div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="tmntLog !== null && tmntLog.length > 0" class="table table-bordered text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col" rowspan="2" class="text-right">Id</th>
          <th scope="col" class="text-center" colspan="2">Contest</th>
          <th scope="col" colspan="2" class="level text-center">Level</th>
          <th scope="col" rowspan="2">Value</th>
          <th scope="col" rowspan="2" class="text-right">
            Time since start<br>
            <span class="font-weight-normal">mm:ss</span>
          </th>
        </tr>
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Type</th>
          <th scope="col">Num</th>
          <th scope="col">Variant proto</th>
        </tr>
      </thead>
      <tr
        v-for="metric in tmntLog"
        :key="metric.id"
      >
        <td class="text-right">
          {{metric.id}}
        </td>
        <td>
          <contest-link :contestId="metric.tmnt_id" />
        </td>
        <td>
          {{metric.tmnt_type | getContestTypeName}}
        </td>
        <td class="level text-right">
          {{convertLevelProtoIdToNum(metric.level)}}
        </td>
        <td class="level">
          {{metric.level | getProtoStr}}
        </td>
        <td class="text-right">
          {{metric.value}}
        </td>
        <td class="text-right">
          {{metric | getMetricTimeStr}}
        </td>
      </tr>
    </table>

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          На&nbsp;данной странице показаны метрики всех конкурсов данного игрока.
        </p>
        <p>
          Метрики хранятся в MySQL на шардах в таблице <code>tmnt_player_metric</code>.
        </p>
        <p>
          У каждой метрики есть числовой идентификатор (id).
        </p>
        <p>
          Каждая метрика относится к какому-то одному конкретному конкурсу (contest).
        </p>
        <p>
          У каждой метрики есть числовое значение (value). Значение метрики — положительное число.
          Для хранения метрики в&nbsp;MySQL использован тип <code>int unsigned</code>.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import ContestLink from './ContestLink.vue';

import { getContestTypeName } from '../model/contest.js';
import { getMetricTimeStr   } from '../model/contest.js';

export default {
  name: 'PlayerContestLog',

  components: {
    LoadingIndicator,
    ContestLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      isLoading: false,
      levelMap: null,
      tmntLog: null,
    };
  },

  computed: {
    /** @returns {?string} */
    message() {
      if(this.tmntLog !== null && this.tmntLog.length === 0) {
        return 'Contest log is empty.';
      }
      return null;
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);
    this.isLoading = true;

    const url = `/player/${this.playerId}/contest_log`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.levelMap = createLevelMap(data.levelMap);
      this.tmntLog = data.log;
    })
    .catch(err => {
      this.isLoading = false;
      notifier.showError(err, {sender: this});
    });
  },

  methods: {
    /**
     * @param {number} levelProtoId
     * @returns {string}
     */
    convertLevelProtoIdToNum(levelProtoId) {
      const levelNum = this.levelMap.get(levelProtoId);
      if(levelNum === undefined) {
        return `Unknown level proto id ${levelProtoId}.`;
      }
      return levelNum;
    },
  },

  filters: {
    getContestTypeName,
    getMetricTimeStr,
  },
};

function createLevelMap(obj) {
  const levelMap = new Map();
  for(const levelProtoIdStr in obj) {
    const levelProtoId = parseInt(levelProtoIdStr, 10);
    const levelId = obj[levelProtoIdStr];
    levelMap.set(levelProtoId, levelId);
  }
  return levelMap;
}
</script>

<style scoped>
.level {
  width: 1px;
}
</style>
